import { useCallback, useRef } from "react";
import { loadHtmlImage } from "utils/loadHtmlImage";
import type { LoadPageImage, UsePageImageLoader } from "./types";

// One decoded image per page URL, shared by every tile that crops from it.
export const usePageImageLoader: UsePageImageLoader = () => {
  const pageImagePromiseByUrlRef = useRef(
    new Map<string, Promise<HTMLImageElement>>(),
  );

  const loadPageImage: LoadPageImage = useCallback((imageUrl) => {
    const promiseByUrl = pageImagePromiseByUrlRef.current;
    const cachedPromise = promiseByUrl.get(imageUrl);
    if (cachedPromise) {
      return cachedPromise;
    }

    const promise = loadHtmlImage({ src: imageUrl });
    promiseByUrl.set(imageUrl, promise);
    // Evict failures so a transient network error can retry on the next tile.
    promise.catch(() => promiseByUrl.delete(imageUrl));
    return promise;
  }, []);

  return { loadPageImage };
};
